import VoicesResults from "../Components/Voices/Results/VoicesResults";

const VoicesResultsPage = () => {
  return <VoicesResults />;
};

export default VoicesResultsPage;
